import React from 'react';

import snakeCase from 'lodash/snakeCase';
import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';

const FieldMappingRow = ({
    field,
    fieldMappingPrefix = '',
    headerFields,
    mappedValue = null,
    defaultOption,
    onChange,
}) => {
    const icon = mappedValue ? 'list-marker-small' : 'list-marker-small-gray';

    return (
        <Row className="mapping-item">
            <Col className="col-sm-3 label-text">
                { field }
            </Col>
            <Col className="col-sm-3 text-center">
                <span className="mapped-icon">
                    <img src={`/img/icons/${icon}.svg`} alt={mappedValue ? 'Mapped' : 'Not mapped'} />
                </span>
            </Col>
            <Col className="col-sm-6 field-select">
                <Form.Control
                    key={`select-field-${snakeCase(field)}`}
                    id={`${fieldMappingPrefix}${snakeCase(field)}`}
                    name={`${fieldMappingPrefix}${snakeCase(field)}`}
                    as="select"
                    value={mappedValue || defaultOption}
                    onChange={(e) => onChange(e.target.value, field)}
                >
                    <option key={`blank-option-${field}`}>
                        {defaultOption}
                    </option>
                    {
                        headerFields.map((hField) => (
                            <option key={`option-${field}-${hField}`}>
                                { hField }
                            </option>
                        ))
                    }
                </Form.Control>
            </Col>
        </Row>
    );
};

FieldMappingRow.propTypes = {
    field: PropTypes.string.isRequired,
    fieldMappingPrefix: PropTypes.string.isRequired,
    headerFields: PropTypes.array.isRequired,
    mappedValue: PropTypes.string,
    defaultOption: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default FieldMappingRow;

